/**
 * sophior-blog-listing.js
 * Kennisbank: client-side paginering (24-kaarten-paneel op de kennisbankpagina)
 * plus de naadloze tab-wissel (navigatievariant, aug 2026).
 *
 * Tab-wissel: de tabs zijn echte links naar de blogindexen. Met JavaScript
 * onderscheppen we de klik, halen we de doelpagina server-gerenderd op en
 * wisselen we de sectie-inhoud in-place; de adresbalk krijgt via pushState de
 * echte blog-URL. Zelfde principe als Dawn's facets (URL-gedreven server-HTML),
 * geen client-side opbouw van kaarten. Vangnetten: zonder JS of bij een
 * fetch-fout navigeert de link gewoon; nieuwe-tab-kliks (ctrl/cmd/shift)
 * blijven ongemoeid.
 */
(function () {
  var ROOT_SELECTOR = '[data-sophior-blog-listing]';

  function initBlogListing(section) {
    if (!section || section.dataset.sophiorBlogInit === '1') return;
    section.dataset.sophiorBlogInit = '1';

    var labelPrev = section.dataset.labelPrev || 'Vorige pagina';
    var labelNext = section.dataset.labelNext || 'Volgende pagina';
    /* 'page' = kennisbank-paginatemplate (eigen page-hero levert de h1);
       'blog' = blogindex-template (h1 + breadcrumbs zitten in de sectie zelf). */
    var context = section.dataset.blogListingContext || 'page';
    var swapController = null;
    var didSwap = false;
    var lastPath = window.location.pathname + window.location.search;

    var canSwap = !!(window.fetch && window.DOMParser && window.history && window.history.pushState);

    /* ---- Client-side paginering over het server-gerenderde paneel ---- */
    function buildPanelPagination(panel) {
      var grid = panel.querySelector('[data-grid]');
      var nav = panel.querySelector('[data-pagination]');
      if (!grid || !nav) return;

      var perPage = parseInt(panel.dataset.articlesPerPage, 10) || 9;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.sophior-blog-listing__card-wrap'));
      var totalPages = Math.ceil(cards.length / perPage);

      if (totalPages <= 1) {
        nav.hidden = true;
        nav.innerHTML = '';
        cards.forEach(function (c) { c.classList.remove('sophior-blog-listing__card-wrap--page-hidden'); });
        return;
      }

      nav.hidden = false;
      nav.innerHTML = '';

      var prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'sophior-blog-listing__page-arrow';
      prevBtn.setAttribute('aria-label', labelPrev);
      prevBtn.innerHTML = '<span aria-hidden="true">←</span>';
      nav.appendChild(prevBtn);

      var numberBtns = [];
      for (var i = 1; i <= totalPages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sophior-blog-listing__page-num';
        b.dataset.page = String(i);
        b.textContent = String(i);
        b.setAttribute('aria-label', 'Pagina ' + i);
        nav.appendChild(b);
        numberBtns.push(b);
      }

      var nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'sophior-blog-listing__page-arrow';
      nextBtn.setAttribute('aria-label', labelNext);
      nextBtn.innerHTML = '<span aria-hidden="true">→</span>';
      nav.appendChild(nextBtn);

      function showPage(page) {
        if (page < 1) page = 1;
        if (page > totalPages) page = totalPages;
        var start = (page - 1) * perPage;
        var end = start + perPage;
        cards.forEach(function (card, idx) {
          if (idx >= start && idx < end) {
            card.classList.remove('sophior-blog-listing__card-wrap--page-hidden');
          } else {
            card.classList.add('sophior-blog-listing__card-wrap--page-hidden');
          }
        });
        numberBtns.forEach(function (b) {
          if (parseInt(b.dataset.page, 10) === page) {
            b.classList.add('sophior-blog-listing__page-num--active');
            b.setAttribute('aria-current', 'page');
          } else {
            b.classList.remove('sophior-blog-listing__page-num--active');
            b.removeAttribute('aria-current');
          }
        });
        prevBtn.disabled = page === 1;
        nextBtn.disabled = page === totalPages;
        panel.dataset.currentPage = String(page);
      }

      function scrollGridIntoView() {
        var wrap = section.querySelector('.sophior-blog-listing__grid-wrap');
        if (!wrap) return;
        requestAnimationFrame(function () {
          wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      prevBtn.addEventListener('click', function () {
        var current = parseInt(panel.dataset.currentPage, 10) || 1;
        if (current <= 1) return;
        showPage(current - 1);
        scrollGridIntoView();
      });

      nextBtn.addEventListener('click', function () {
        var current = parseInt(panel.dataset.currentPage, 10) || 1;
        if (current >= totalPages) return;
        showPage(current + 1);
        scrollGridIntoView();
      });

      numberBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          showPage(parseInt(this.dataset.page, 10));
          scrollGridIntoView();
        });
      });

      showPage(1);
    }

    function initPanels() {
      section.querySelectorAll('[data-blog-panel]').forEach(buildPanelPagination);
    }

    /* De tab- en chiprijen scrollen horizontaal. Staat de actieve pill buiten
       beeld (bijv. "Inspiratie", de vijfde tab op een 375px-scherm), dan lijkt
       het alsof je nergens staat. Centreer hem daarom binnen zijn eigen rij —
       zonder de pagina zelf te verschuiven (inline-scroll op de container). */
    function centreerActievePills() {
      section.querySelectorAll('.sophior-blog-listing__tabs-wrap, .sophior-blog-listing__chips-wrap').forEach(function (wrap) {
        if (wrap.scrollWidth <= wrap.clientWidth) return;
        var actief = wrap.querySelector('[aria-current="page"]');
        if (!actief) return;
        var doel = actief.offsetLeft - (wrap.clientWidth - actief.offsetWidth) / 2;
        wrap.scrollLeft = Math.max(0, doel);
      });
    }

    /* ---- Naadloze tab-wissel ---- */
    function setLoading(on) {
      var wrap = section.querySelector('.sophior-blog-listing__grid-wrap');
      if (wrap) wrap.classList.toggle('is-loading', on);
    }

    function swapTo(url, push, scrollTarget) {
      if (swapController) swapController.abort();
      swapController = window.AbortController ? new AbortController() : null;
      setLoading(true);

      var opts = { headers: { Accept: 'text/html' } };
      if (swapController) opts.signal = swapController.signal;

      return fetch(url, opts)
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector(ROOT_SELECTOR);
          if (!fresh) throw new Error('blog-listing-sectie niet gevonden in ' + url);

          if (context === 'page') {
            /* De kennisbankpagina heeft zijn eigen page-hero (h1 "Kennisbank");
               de blogindex-header (kruimel + h1 + intro + beeld) niet
               mee-injecteren. De __breadcrumbs/__intro-takken blijven staan
               als vangnet voor gecachete HTML van vóór de split-header. */
            var freshHeader = fresh.querySelector('.sophior-blog-listing__header');
            if (freshHeader) freshHeader.remove();
            var freshCrumbs = fresh.querySelector('.sophior-blog-listing__breadcrumbs');
            if (freshCrumbs) freshCrumbs.remove();
            var freshIntro = fresh.querySelector('.sophior-blog-listing__intro');
            var ownIntro = section.querySelector('.sophior-blog-listing__intro');
            if (freshIntro && ownIntro) {
              freshIntro.replaceWith(ownIntro);
            } else if (freshIntro) {
              freshIntro.remove();
            }
          }
          /* De sectie-eigen script-tag niet opnieuw injecteren */
          fresh.querySelectorAll('script').forEach(function (s) { s.remove(); });

          section.innerHTML = fresh.innerHTML;
          if (doc.title) document.title = doc.title;
          initPanels();
          centreerActievePills();

          if (push) window.history.pushState({ sophiorBlogSwap: true }, '', url);
          lastPath = window.location.pathname + window.location.search;
          didSwap = true;

          if (scrollTarget === 'grid') {
            /* Paginering: terug naar de top van het (nieuwe) grid, net als de
               client-side paginering doet (scroll-margin-top staat in de CSS) */
            var gridWrap = section.querySelector('.sophior-blog-listing__grid-wrap');
            if (gridWrap) gridWrap.scrollIntoView({ block: 'start' });
          } else {
            /* Tabs in beeld houden als de bezoeker al voorbij de tab-balk was */
            var tabsWrap = section.querySelector('.sophior-blog-listing__tabs-wrap');
            if (tabsWrap && tabsWrap.getBoundingClientRect().top < 0) {
              tabsWrap.scrollIntoView({ block: 'start' });
            }
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          /* Vangnet: gewoon navigeren */
          window.location.href = url;
        })
        .then(function () {
          setLoading(false);
        });
    }

    section.addEventListener('click', function (event) {
      /* Nieuwe-tab/venster-kliks hun gang laten gaan */
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var tab = event.target.closest('.sophior-blog-listing__tab[data-blog-nav-handle]');
      if (tab) {
        if (tab.getAttribute('aria-current') === 'page') {
          event.preventDefault();
          return;
        }
        /* Tab-wissels via pushState genereren geen page_view; eigen event
           zodat kennisbank-navigatie zichtbaar blijft in analytics */
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('sophior_kennisbank_tab', {
            handle: tab.dataset.blogNavHandle || '',
            path: window.location.pathname
          });
        }
        if (!canSwap) return;
        event.preventDefault();
        swapTo(tab.href, true);
        return;
      }

      /* Onderwerp-chips (tagged-weergaven) door hetzelfde naadloze kanaal.
         Meet-event via Shopify.analytics (zelfde patroon als de quick-add):
         pas uitbreiden naar meer categorieën als dit aantoonbaar gebruikt wordt. */
      var chip = event.target.closest('.sophior-blog-listing__chip[data-blog-tag-link]');
      if (chip) {
        if (chip.getAttribute('aria-current') === 'page') {
          event.preventDefault();
          return;
        }
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('sophior_kennisbank_chip', {
            tag: chip.dataset.chipTag || '',
            path: window.location.pathname
          });
        }
        if (!canSwap) return;
        event.preventDefault();
        swapTo(chip.href, true);
        return;
      }

      /* Server-paginering van de blogindex (?page=2) door hetzelfde naadloze
         kanaal: grid wisselt in-place, URL krijgt het paginanummer. */
      var pageLink = event.target.closest('.sophior-blog-listing__pagination a[href]');
      if (pageLink) {
        if (!canSwap) return;
        event.preventDefault();
        swapTo(pageLink.href, true, 'grid');
      }
    });

    window.addEventListener('popstate', function () {
      if (!didSwap) return;
      var path = window.location.pathname + window.location.search;
      if (path === lastPath) return;
      swapTo(path, false);
    });

    /* Oude deeplinks (/pages/kennisbank#pannen, van vóór de navigatievariant):
       naadloos doorwisselen naar de blogindex; zonder swap-ondersteuning een
       gewone redirect. */
    function handleHash() {
      var hash = window.location.hash.replace('#', '');
      if (!hash || !/^[a-z0-9-]+$/.test(hash)) return;
      var navTarget = section.querySelector('.sophior-blog-listing__tab[data-blog-nav-handle="' + hash + '"]');
      if (!navTarget || navTarget.getAttribute('aria-current') === 'page') return;
      if (canSwap) {
        window.history.replaceState({}, '', window.location.pathname + window.location.search);
        swapTo(navTarget.href, true);
      } else {
        window.location.replace(navTarget.href);
      }
    }

    initPanels();
    centreerActievePills();
    handleHash();
    window.addEventListener('hashchange', handleHash);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initBlogListing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
